import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import classNames from 'classnames';

import Page from 'components/ui/page';

import nl2br from 'react-nl2br';

import _ from 'lodash';

import './news.less';
import {connect} from "react-redux";
import {getNews, getTags} from "store/reducers/news";
import moment from "moment";
import formats from "dictionaries/formats";
import {Link} from "react-router";
import GlobalLoaderComponent from "components/ui/global-loader";
import renderHTML from 'react-render-html';
import TagsComponent from "components/modules/news/tags";

@connect((state) => ({}), {getNews})

export default class NewsSidebarComponent extends Component {

    state = {
        otherNews: [],
    };

    months = [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря',
    ];

    componentDidMount() {
        this.loadOtherNews();
    }

    async loadOtherNews() {
        const response = await this.props.getNews({
            filters: {
                onlyActive: true,
                withPinned: [
                    false,
                ],
            },
            pagination: {
                page: 2,
                limit: 9,
            },
            order: {
                column: 'timestamp',
                direction: 'desc',
            },
        });
        if (response.isOk) {
            const news = response.payload.items;
            this.setState({
                otherNews: news,
            });
        } else {
            response.showErrors();
        }
    }

    render() {
        const loader = this.state.loading ? <GlobalLoaderComponent/> : null;

        return (
            <div className="sidebar">
                <div className="sidebar__title">Другие новости портала</div>
                <ul className="sidebar-news-list">
                    {this.state.otherNews.map(::this.renderSidebarNews)}
                </ul>
                <a href="javascript:void(0)"
                   className="b-button b-button_size_md b-button_white b-button_shadow_gray b-button-more"
                   onClick={::this.showAll}>Все новости</a>
                <TagsComponent {...this.props}/>
            </div>
        );
    }

    showAll() {
        this.props.router.push('/news/all');
    }

    renderPage(page, index) {
        const className = classNames({
            active: page + 1 === 1 * this.state.page,
        });

        return (
            <Link key={index} to={`/news?page=${page + 1}`} className={className}>{page + 1}</Link>
        );
    }

    renderNews(news) {
        const {uuid, title, timestamp, image} = news;

        return (
            <li key={uuid} className="news-item">
                <div className="news-item__img" style={{backgroundImage: `url(${image})`}}/>
                <div className="news-item__content">
                    <div className="news-item__title" onClick={this.showFull.bind(this, uuid)}>{title}</div>
                    <div className="news-item__date">{this.formatTimestamp(timestamp)}</div>
                </div>
            </li>
        );
    }

    formatTimestamp(timestamp) {
        return (
            <span>
                {moment(timestamp).format('D')} {this.months[moment(timestamp).format('MM') - 1]} {moment(timestamp).format('YYYY')} г.
            </span>
        );
    }

    showFull(uuid) {
        this.props.router.push(`/news/${uuid}`);
    }

    renderSidebarNews(news) {
        const {uuid, title, timestamp} = news;

        return (
            <li key={uuid} className="sidebar-news-item">
                <div className="sidebar-news-item__title" onClick={this.showFull.bind(this, uuid)}>{title}</div>
                <div className="sidebar-news-item__date">{this.formatTimestamp(timestamp)}</div>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/modules/news/sidebar.js